import { shallowMount } from "@vue/test-utils";
import ModalSms from "@/components/core/modals/ModalSms";

describe("ModalSms component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(ModalSms);
  });

  it("Renders del component ModalSms", () => {
    expect(wrapper).toBeDefined();
  });
});
